import React from 'react';
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";


const UiSwitch = (props) => {

  const {textId, checked, onClick, className} = props;

  return (
    <div className={"ui-switch" + (checked ? " ui-switch--checked" : "") + (className ? " " + className : "")}
         onClick={onClick}>
      <div className="ui-switch__body"/>
      {textId ? (
        <span className="ui-switch__text">
          <FormattedMessage id={textId}/>
        </span>
      ) : null}
    </div>
  )
};

UiSwitch.propTypes = {
  className: PropTypes.string,
  textId: PropTypes.string,
  onClick: PropTypes.func,
  checked: PropTypes.bool.isRequired,
}

export default UiSwitch;
